import React, { useState, useEffect, useRef, useContext } from "react";
import { UserContext } from "../../context/UserContext";
import { useNavigate } from "react-router-dom";
import { FiUser } from "react-icons/fi";

const Header = () => {
  const { name, profileUrl, primaryEmail, userRole } = useContext(UserContext);
  const [isPopupVisible, setIsPopupVisible] = useState(false);
  const profilePopupRef = useRef(null);
  const profileTriggerRef = useRef(null);

  const navigate = useNavigate();


  // Toggle the popup visibility
  const togglePopup = () => {
    setIsPopupVisible((prev) => !prev);
  };

  // Close popup on outside click
  useEffect(() => {
    const handleOutsideClick = (event) => {
      if (
        profilePopupRef.current &&
        !profilePopupRef.current.contains(event.target) &&
        profileTriggerRef.current &&
        !profileTriggerRef.current.contains(event.target)
      ) {
        setIsPopupVisible(false);
      }
    };

    document.addEventListener("click", handleOutsideClick);
    return () => {
      document.removeEventListener("click", handleOutsideClick);
    };
  }, []);

  const handleLogout = () => {
    // Clear user session data
    localStorage.clear();
    sessionStorage.clear();

    // Replace the history state to prevent back navigation
    window.history.replaceState(null, null, "/");

    // Forcefully reload the page to clear all states
    setTimeout(() => {
      window.location.href = "/";
    }, 100); // Slight delay to ensure changes take effect
  };


  return (
    <header className="fixed top-0 left-0 right-0 bg-white shadow-md flex items-center justify-between px-6 py-4 z-50">
      {/* Logo */}
      <img src="/Assets/logo-01.png" alt="logo" className="h-10" />
      <div className="flex items-center space-x-6">
        <div className="relative">
          <div
            className="flex items-center cursor-pointer space-x-2"
            ref={profileTriggerRef}
            onClick={togglePopup}
          >
            {/* Profile Picture or Placeholder */}
            {userRole === "Admin" ? (
              // Render SVG for Admin
              <FiUser className="size-7 font-thin" />
            ) : (profileUrl === "null" || profileUrl === null) ? (
              // Render placeholder if no profile picture
              <div className="w-10 h-10 bg-blue-400 rounded-full flex items-center justify-center text-white font-semibold">
                {name ? name.charAt(0).toUpperCase() : "?"}
              </div>
            ) : (
              // Render profile picture
              <img
                src={profileUrl}
                alt="Profile"
                className="size-10 rounded-full object-cover"
              />
            )}
            <span className="text-sm font-normal text-gray-700">
              {userRole !== "Admin" && 'Greetings, '} {name}
            </span>
          </div>
          {/* Profile Pop-up */}
          <div
            className={`absolute top-12 right-0 bg-white shadow-lg w-64 ${isPopupVisible ? "" : "hidden"
              }`}
            ref={profilePopupRef}
          >
            <div className="bg-gradient-to-r from-blue-400 to-blue-900 text-white p-4 rounded-t-lg flex items-center space-x-4">
              {userRole === "Admin" ? (
                // Render SVG for Admin in popup
                <FiUser className="size-8" />
              ) : (profileUrl === "null" || profileUrl === null) ? (
                // Render placeholder if no profile picture
                <div className="w-12 h-12 bg-white rounded-full flex items-center justify-center text-gray-600">
                  {name ? name.charAt(0).toUpperCase() : "?"}
                </div>
              ) : (
                <img
                  src={profileUrl}
                  alt="Profile"
                  className="w-12 h-12 rounded-full object-cover"
                />
              )}
              <div>
                <h3 className="font-bold text-lg">{name || "User Name"}</h3>
                <h4 className="text-xs font-thin text-red">
                  {primaryEmail || "user@example.com"}
                </h4>
              </div>
            </div>
            {userRole === "Student" && (
              <div
                className="p-4 space-y-3 cursor-pointer hover:bg-blue-100 transition-transform hover:translate-x-2 group"
                onClick={() => navigate("/profile")}
              >
                {/* My Profile Section */}
                <div className="flex items-center space-x-4">
                  <FiUser className="size-6 text-gray-600 group-hover:text-blue-900" />
                  <div>
                    <span className="text-sm text-gray-700 group-hover:text-blue-900 font-semibold">My Profile</span>
                    <p className="text-xs text-gray-500 group-hover:text-blue-900 ">Account settings and more</p>
                  </div>
                </div>

              </div>
            )}
            {userRole === "SalesPerson" && (
              <div
                className="p-4 space-y-3 cursor-pointer hover:bg-blue-100 transition-transform hover:translate-x-2 group"
                onClick={() => {
                  setIsPopupVisible(false);
                  navigate("/sales/account");
                }}
              >
                <div className="flex items-center space-x-4">
                  <FiUser className="size-6 text-gray-600 group-hover:text-blue-900" />
                  <div>
                    <span className="text-sm text-gray-700 group-hover:text-blue-900 font-semibold">My Account</span>
                    <p className="text-xs text-gray-500 group-hover:text-blue-900 ">Change email and password</p>
                  </div>
                </div>
              </div>
            )}
            {/* Logout Section */}
            <div
              onClick={handleLogout}
              className="p-4 border-t flex items-start space-x-4 cursor-pointer hover:bg-gray-200 transition-transform hover:translate-x-2 group"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                className="h-6 w-6 text-red-500"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="2"
                  d="M17 16l4-4m0 0l-4-4m4 4H7"
                />
              </svg>
              <div>
                <span className="text-sm text-red-500 font-semibold">Logout</span>
                <p className="text-xs mt-1 text-red-400">Logout to home page</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </header>
  );
};

export default Header;